import VCascaderCardType from './index.vue';

export default {
  install: (Vue) => Vue.component('VCascaderCardType', VCascaderCardType),
};
